import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { SettingsProvider } from "./contexts/SettingsContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Orders from "./pages/Orders";
import Services from "./pages/Services";
import Invoices from "./pages/Invoices";
import InvoiceView from "./pages/InvoiceView";
import Khatabook from "./pages/Khatabook";
import Students from "./pages/Students";
import Users from "./pages/Users";
import Settings from "./pages/Settings";

function Shell({ children }) {
    return (
        <ProtectedRoute>
            <Layout>{children}</Layout>
        </ProtectedRoute>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <SettingsProvider>
                        <Toaster theme="dark" richColors position="top-right" />
                        <Routes>
                            <Route path="/login" element={<Login />} />
                            <Route path="/" element={<Shell><Dashboard /></Shell>} />
                            <Route path="/orders" element={<Shell><Orders /></Shell>} />
                            <Route path="/services" element={<Shell><Services /></Shell>} />
                            <Route path="/invoices" element={<Shell><Invoices /></Shell>} />
                            <Route path="/invoices/:id" element={<Shell><InvoiceView /></Shell>} />
                            <Route path="/khatabook" element={<Shell><Khatabook /></Shell>} />
                            <Route path="/students" element={<Shell><Students /></Shell>} />
                            <Route path="/users" element={<Shell><Users /></Shell>} />
                            <Route path="/settings" element={<Shell><Settings /></Shell>} />
                        </Routes>
                    </SettingsProvider>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
